module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-x-68130804.svg";